import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET  filemanager/api/v3/files/{fontId}
 */

export function fetchFile(id, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`filemanager/api/v3/files/${id}`);
}